export function sortTreeByAttr<T extends { id: string; children: T[] }>(
  arr: T[],
  attr: keyof T
) {
  const sorted = arr.sort((a, b) =>
    a[attr] > b[attr] ? 1 : a[attr] === b[attr] ? 0 : -1
  );

  sorted.forEach((root) => {
    if (root.children && root.children.length) {
      root.children = sortTreeByAttr(root.children, attr);
    }
  });

  return sorted;
}
